import { Link } from "react-router-dom";
import { MapPin, Clock, Phone, Mail, Building2, Smartphone, FileText } from "lucide-react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_8465ce77-9585-4fff-bcf3-0cae1d417cf9/artifacts/w0kkj7ub_WhatsApp_Image_2026-02-27_at_19.16.07-removebg-preview%20%282%29.png";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#f5f6f4] mt-24 border-t border-black/[0.05]"
    >
      <div className="absolute inset-x-0 -top-px h-px bg-gradient-to-r from-transparent via-[#5ab500]/60 to-transparent" />

      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10">
          {/* Brand */}
          <div className="lg:col-span-4">
            <div className="flex items-center gap-3 mb-5">
              <img
                src={LOGO_URL}
                alt="Minicarmobilità"
                className="h-12 w-12 rounded-full bg-black ring-1 ring-black/10"
              />
              <div>
                <div className="font-heading text-xl font-bold text-[#1c1f1a] leading-tight">
                  Minicar<span className="text-[#5ab500]">mobilità</span>
                </div>
                <div className="text-[10px] uppercase tracking-[0.2em] text-[#7a7f77] mt-0.5 font-semibold">
                  Micromobilità Licari S.r.l.s.
                </div>
              </div>
            </div>
            <p className="text-sm text-[#4a4f47] max-w-sm leading-relaxed">
              La tua concessionaria di fiducia per scooter cabinati e auto
              usate selezionate. Mobilità innovativa, sicurezza certificata.
            </p>
            <div className="mt-6 space-y-1.5 text-xs text-[#7a7f77]">
              <div>P.IVA: <span className="font-semibold text-[#4a4f47]">14669860968</span></div>
              <div className="flex items-center gap-1.5">
                <FileText size={11} className="text-[#5ab500]" />
                PEC:{" "}
                <a
                  href="mailto:auto.licari@legalmail.it"
                  data-testid="footer-pec"
                  className="font-semibold text-[#4a4f47] hover:text-[#5ab500]"
                >
                  auto.licari@legalmail.it
                </a>
              </div>
            </div>
          </div>

          {/* Negozio */}
          <div className="lg:col-span-2">
            <div className="text-[11px] uppercase tracking-[0.25em] text-[#5ab500] mb-4 flex items-center gap-2 font-bold">
              <MapPin size={12} /> Negozio
            </div>
            <address className="not-italic text-sm text-[#1c1f1a] leading-relaxed">
              Via Puccini 5<br />
              Zibido San Giacomo (MI)
              <br />
              20058
            </address>
          </div>

          {/* Sede fiscale */}
          <div className="lg:col-span-3">
            <div className="text-[11px] uppercase tracking-[0.25em] text-[#5ab500] mb-4 flex items-center gap-2 font-bold">
              <Building2 size={12} /> Sede Fiscale
            </div>
            <address className="not-italic text-sm text-[#1c1f1a] leading-relaxed">
              V. Giuseppe Dezza, 24
              <br />
              20144 Milano
            </address>

            <div className="mt-6 text-[11px] uppercase tracking-[0.25em] text-[#5ab500] mb-3 flex items-center gap-2 font-bold">
              <Clock size={12} /> I Nostri Orari
            </div>
            <div className="text-sm text-[#1c1f1a] leading-relaxed">
              Lun–Ven: 9:00–19:00
              <br />
              Sabato: 9:00–14:00
            </div>
          </div>

          {/* Contatti */}
          <div className="lg:col-span-3">
            <div className="text-[11px] uppercase tracking-[0.25em] text-[#5ab500] mb-4 flex items-center gap-2 font-bold">
              <Phone size={12} /> Contatti
            </div>
            <a
              href="tel:+393297452439"
              data-testid="footer-mobile"
              className="flex items-center gap-2 text-sm text-[#1c1f1a] hover:text-[#5ab500] transition mb-2 font-semibold"
            >
              <Smartphone size={14} className="text-[#5ab500]" />
              CEL. 329 745 2439
            </a>
            <a
              href="tel:+390243511941"
              data-testid="footer-phone"
              className="flex items-center gap-2 text-sm text-[#1c1f1a] hover:text-[#5ab500] transition mb-2 font-semibold"
            >
              <Phone size={14} className="text-[#5ab500]" />
              TEL. 02 4351 1941
            </a>
            <a
              href="mailto:auto.licari26@gmail.com"
              data-testid="footer-email"
              className="flex items-center gap-2 text-sm text-[#4a4f47] hover:text-[#5ab500] transition break-all"
            >
              <Mail size={14} className="text-[#5ab500]" />
              auto.licari26@gmail.com
            </a>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-black/[0.08] flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-[#7a7f77]">
          <div>
            © {new Date().getFullYear()} Micromobilità Licari S.r.l.s. — Tutti i
            diritti riservati.
          </div>
          <div className="flex items-center gap-6">
            <Link
              to="/privacy"
              data-testid="footer-privacy-link"
              className="hover:text-[#5ab500] transition"
            >
              Privacy Policy
            </Link>
            <Link
              to="/privacy"
              data-testid="footer-cookie-link"
              className="hover:text-[#5ab500] transition"
            >
              Cookie Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
